module.exports = __webpack_public_path__ + "img/Dantam Hair 53.69fea8b6.jpg";